import React from 'react'
import classnames from 'classnames'
import injectStyles from 'react-jss'

import SettingsIcon from 'Assets/Images/icons/reportSettings'
import UploadIcon from 'Assets/Images/icons/reportUpload'
import TickIcon from 'Assets/Images/icons/tick'
import ShowReportType from '../../../../../Components/Campaigns/Page/Conversions/ShowReportType'
import StyledIconButton from '../../../../../Components/Form/StyledIconButton'
import SubmitButton from '../../../../../Components/Form/SubmitButton'
import { StyledCancelButton } from '../../../../../Components/Campaigns/Page/Conversions/CountdownTimer/styles'

import { reportTemplateCSVFileContent } from './../../../../../Utils/Conversion'
import { CONVERSION_REPORT_TYPE } from '../../../../../shared/constants'

import styles from '../styles'

const ConversionsView = ({
  reportType,
  campaignName,
  metrics,
  reportFile,
  onClickReportType,
  onUploadReport,
  onRemoveReport,
  onSubmitReport,
  fileUploader,
  children,
  classes,
}) => (
  <section className={classes.wrapper}>
    <section className={classes.fileUploaderWrapper}>
      {fileUploader}
      <section className={classes.operation}>
        <section className={classes.leftOperation}>
          <StyledIconButton
            className={classes.setting}
            onClick={onClickReportType}
          >
            <SettingsIcon />
          </StyledIconButton>
          <ShowReportType
            reportType={reportType}
            templateCSVFile={reportTemplateCSVFileContent(
              campaignName,
              metrics,
              reportType === CONVERSION_REPORT_TYPE.WITH_TIMESTAMP,
            )}
          />
        </section>
        <section>
          {reportFile && (
            <StyledCancelButton onClick={onRemoveReport}>
              Cancel
            </StyledCancelButton>
          )}
          {reportFile ? (
            <SubmitButton className={classes.upload} onClick={onSubmitReport}>
              <span className={classes.uploadIcon}>
                <TickIcon />
              </span>
              Submit
            </SubmitButton>
          ) : (
            <SubmitButton
              className={classnames(classes.upload, {
                [classes.disableButton]:
                  reportType === CONVERSION_REPORT_TYPE.NO_TYPE,
              })}
              onClick={onUploadReport}
              disabled={metrics.length === 0}
            >
              <span className={classes.uploadIcon}>
                <UploadIcon />
              </span>
              Upload report
            </SubmitButton>
          )}
        </section>
      </section>
    </section>
    <section className={classes.childrenWrapper}>{children}</section>
  </section>
)

export default injectStyles(styles)(ConversionsView)
